/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
import React, {useEffect, useState} from 'react';

import {observer} from 'mobx-react';
import {useStore} from '../../../store/store';
import {useLocation} from 'react-router';
import {formatNumberToCash} from '../../functions/formatNumber';
import PageWrapper from '../../modules/PageWrapper';
import {useFullWidth} from '../../hooks/useFullWidth';

import ProfileHeader from './ProfileHeader';
import Details from './pages/Details';
import Settings from './pages/Settings';
import Billing from './pages/Billing';
import Security from './pages/Security';
import ProfileHeaderStats from './ProfileHeaderStats';

const Profile = observer(({isVerify, setPreloader}) => {
  useFullWidth();
  const location = useLocation();
  const store = useStore();

  const [data, setData] = useState();

  useEffect(() => {
    if (!isVerify) return;
    (async () => {
      const [result, getData, roles, countries] = await Promise.all([
        store.requestGet('myAccount/getMainData'),
        store.requestGet('myAccount/getData'),
        store.requestGet('Users/getAllAccess'),
        store.requestGet('Countries/getList'),
      ]);
      const country = countries.find((el) => el.id === result.countries_id);
      const role = roles.roles.find((el) => el.id === result.role_id);

      setData({...result, ...getData, geo: country?.name, role_name: role?.name});
      setPreloader(false);
    })();
  }, [isVerify]);

  return (
    <>
      <ProfileHeader
        data={data}
        navigation={[
          {link: '/account/info', title: 'Данные'},
          {link: '/account/settings', title: 'Настройки'},
          {link: '/account/billing', title: 'Платежная информация'},
          {link: '/account/security', title: 'Безопасность'},
        ]}
      >
        <ProfileHeaderStats
          title={'Выплачено'}
          StatsUpDown={false}
          stats={formatNumberToCash(data?.account_payments)}
        />
        <ProfileHeaderStats
          title={'Текущий баланс'}
          StatsUpDown={true}
          stats={formatNumberToCash(data?.balance)}
        />
      </ProfileHeader>
      {location.pathname === '/account/info' && <Details data={data} />}
      {location.pathname === '/account/settings' && (
        <Settings
          getSettings={async () => {
            const result = await store.requestGet('myAccount/getSettings');

            return result;
          }}
        />
      )}
      {location.pathname === '/account/billing' && (
        <Billing
          getWallets={async () => {
            const result = await store.requestGet('myAccount/getWallets');

            return result;
          }}
          getTransactions={async () => {
            const result = await store.requestGet('myAccount/getTransactions');

            return result;
          }}
        />
      )}
      {location.pathname === '/account/security' && (
        <Security
          getAuthData={async () => {
            const result = await store.requestGet('myAccount/getAuthData', {
              params: {type: 1},
            });

            return result;
          }}
        />
      )}
    </>
  );
});

const ProfileWrapper = () => {
  const [breadcrumbs, setBreadcrumbs] = useState({br: [], title: ''});
  const location = useLocation();
  const store = useStore();

  useEffect(() => {
    store.setToolbarType('');

    switch (location.pathname) {
      case '/account/info': {
        setBreadcrumbs({
          br: [
            {title: 'Panely', path: '/dashboard'},
            {isSeparator: true},
            {title: 'Мой Аккаунт', path: '/account/info', isActive: true},
          ],
          title: 'Мой аккаунт',
        });
        break;
      }
      case '/account/settings': {
        setBreadcrumbs({
          br: [
            {title: 'Panely', path: '/dashboard'},
            {isSeparator: true},
            {title: 'Мой Аккаунт', path: '/account/settings', isActive: true},
          ],
          title: 'Мой аккаунт',
        });
        break;
      }
      case '/account/billing': {
        setBreadcrumbs({
          br: [
            {title: 'Panely', path: '/dashboard'},
            {isSeparator: true},
            {title: 'Мой Аккаунт', path: '/account/billing', isActive: true},
          ],
          title: 'Мой аккаунт',
        });
        break;
      }
      case '/account/security': {
        setBreadcrumbs({
          br: [
            {title: 'Panely', path: '/dashboard'},
            {isSeparator: true},
            {title: 'Мой Аккаунт', path: '/account/security', isActive: true},
          ],
          title: 'Мой аккаунт',
        });
        break;
      }
    }
  }, [location]);

  return (
    <PageWrapper breadcrumbs={breadcrumbs.br} title={breadcrumbs.title}>
      <Profile />
    </PageWrapper>
  );
};

export default observer(ProfileWrapper);
